<div class="max-w-2xl">
  <h2 mat-dialog-title>Registro de Proveedor - Arcelor Mittal</h2>
  
  <mat-dialog-content>
    @if (showSuccessMessage) {
      <!-- Success Message -->
      <div class="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
        <div class="text-green-600 mb-4">
          <mat-icon class="text-5xl">check_circle</mat-icon>
        </div>
        <h3 class="text-lg font-semibold text-green-800 mb-3">¡Registro Exitoso!</h3>
        <p class="text-green-700 leading-relaxed">
          Gracias por generar tu registro estimado proveedor, ahora puedes ingresar con el correo electrónico que registraste como tu usuario para solicitar tu integración en esta misma plataforma.
        </p>
      </div>
    } @else {
      <!-- Registration Form -->
      <form [formGroup]="providerForm">
        
        <!-- Información de la Empresa -->
        <div class="text-lg font-semibold text-gray-700 mb-4 mt-6 first:mt-0 border-b border-gray-200 pb-2">
          Información de la Empresa
        </div>
      
      <mat-form-field class="w-full mb-4" appearance="outline">
        <mat-label>Razón Social</mat-label>
        <input matInput formControlName="commercialName" placeholder="Ej: TRANSPORTES DEL NORTE">
        @if (providerForm.get('commercialName')?.invalid && providerForm.get('commercialName')?.touched) {
          <mat-error>{{ getErrorMessage('commercialName') }}</mat-error>
        }
      </mat-form-field>

      <div class="flex gap-4 mb-4">
        <mat-form-field class="flex-1" appearance="outline">
          <mat-label>RFC</mat-label>
          <input matInput formControlName="rfc" placeholder="ABC123456XYZ" class="uppercase">
          @if (providerForm.get('rfc')?.invalid && providerForm.get('rfc')?.touched) {
            <mat-error>{{ getErrorMessage('rfc') }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field class="flex-1" appearance="outline">
          <mat-label>Número de proveedor de Arcelor Mittal</mat-label>
          <input matInput formControlName="providerNumber" placeholder="abc00123">
          @if (providerForm.get('providerNumber')?.invalid && providerForm.get('providerNumber')?.touched) {
            <mat-error>{{ getErrorMessage('providerNumber') }}</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Contactos -->
      <div class="text-lg font-semibold text-gray-700 mb-4 mt-6 border-b border-gray-200 pb-2">
        Datos de contacto (será tu usuario de acceso)
      </div>
      
      <div formArrayName="contacts">
        @for (contact of contacts.controls; track $index) {
          <div [formGroupName]="$index" class="border border-gray-200 rounded-lg p-4 mb-4">
            <div class="flex justify-between items-center mb-4">
              <h4 class="text-base font-medium text-gray-600 m-0">Contacto {{ $index + 1 }}</h4>
              @if (contacts.length > 1) {
                <button mat-icon-button type="button" (click)="removeContact($index)" color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>

            <mat-form-field class="w-full mb-4" appearance="outline">
              <mat-label>Nombre Completo</mat-label>
              <input matInput formControlName="name" placeholder="Ej: Juan Carlos Pérez">
              @if (contact.get('name')?.invalid && contact.get('name')?.touched) {
                <mat-error>{{ getErrorMessage('name', $index) }}</mat-error>
              }
            </mat-form-field>

            <div class="flex gap-4 mb-4">
              <mat-form-field class="flex-1" appearance="outline">
                <mat-label>Correo Electrónico</mat-label>
                <input matInput formControlName="email" type="email" placeholder="correo@empresa.com">
                @if (contact.get('email')?.invalid && contact.get('email')?.touched) {
                  <mat-error>{{ getErrorMessage('email', $index) }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field class="flex-1" appearance="outline">
                <mat-label>Teléfono</mat-label>
                <input matInput formControlName="phone" placeholder="5550123456" type="tel">
                @if (contact.get('phone')?.invalid && contact.get('phone')?.touched) {
                  <mat-error>{{ getErrorMessage('phone', $index) }}</mat-error>
                }
              </mat-form-field>
            </div>

            <mat-form-field class="w-full mb-4" appearance="outline">
              <mat-label>Tipo de Contacto</mat-label>
              <mat-select formControlName="type">
                @for (type of contactTypes; track type.value) {
                  <mat-option [value]="type.value">{{ type.label }}</mat-option>
                }
              </mat-select>
              @if (contact.get('type')?.invalid && contact.get('type')?.touched) {
                <mat-error>{{ getErrorMessage('type', $index) }}</mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>

        <!-- <button mat-stroked-button type="button" (click)="addContact()" class="mb-4 w-full">
          <mat-icon>add</mat-icon>
          Agregar Contacto
        </button> -->

        <!-- Error Message -->
        @if (errorMessage) {
          <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
            <div class="flex items-center">
              <mat-icon class="text-red-500 mr-2">error</mat-icon>
              <p class="text-red-700 m-0">{{ errorMessage }}</p>
            </div>
          </div>
        }

      </form>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (showSuccessMessage) {
      <button mat-raised-button color="primary" (click)="onCancel()">
        Cerrar
      </button>
    } @else {
      <button mat-button (click)="onCancel()" [disabled]="isSubmitting">Cancelar</button>
      <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="providerForm.invalid || isSubmitting">
        @if (isSubmitting) {
          <mat-icon class="mr-2 animate-spin">refresh</mat-icon>
          Registrando...
        } @else {
          Registrar Proveedor
        }
      </button>
    }
  </mat-dialog-actions>
</div>